"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./Spinner.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var spinnerClasses = (0, _cssClassesHelper.getBEMClasses)('spinner');
var Spinner = function Spinner(_ref) {
  var isVisible = _ref.isVisible,
    isInline = _ref.isInline,
    text = _ref.text,
    customClass = _ref.customClass,
    classModifiers = _ref.classModifiers;
  var baseClass = typeof customClass === 'string' ? (0, _cssClassesHelper.getBEMClasses)(customClass) : customClass || function () {
    return '';
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isVisible && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(spinnerClasses('container', isInline && 'inline'), " ").concat(baseClass('spinner-container', classModifiers))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(spinnerClasses('circle', isInline && 'inline'), " ").concat(baseClass('spinner-circle', classModifiers))
  }), text && /*#__PURE__*/_react["default"].createElement("div", {
    className: spinnerClasses('text')
  }, text)));
};
Spinner.propTypes = {
  isInline: _propTypes["default"].bool,
  isVisible: _propTypes["default"].bool.isRequired,
  customClass: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
  text: _propTypes["default"].string
};
Spinner.defaultProps = {
  isVisible: true
};
var _default = exports["default"] = Spinner;